// extracted by mini-css-extract-plugin
module.exports = {"summary":"MealsSummary_summary__22zUX","summary-appear":"MealsSummary_summary-appear__2Qu64"};